import { useCallback, useEffect } from 'react'

import { isEmpty } from 'lodash'

import { useWaitTx } from 'hooks/wallet'

import { Transaction } from 'state/user/types'
import { usePendingTransactions, useUpdateTransactionHistory } from 'state/user/hooks'

const processingTxs = new Map()

export function usePendingTransactionsListener() {
  const pendingTxs = usePendingTransactions()

  const waitForTransaction = useWaitTx()
  const updateTransactionHistory = useUpdateTransactionHistory()

  const handleTxResult = useCallback(
    (tx: Transaction) => {
      updateTransactionHistory(tx)
      processingTxs.delete(tx.txHash)
    },
    [processingTxs],
  )

  const onTxHandling = useCallback(async () => {
    for (const tx of Object.values(pendingTxs)) {
      if (!processingTxs.has(tx.txHash)) {
        processingTxs.set(tx.txHash, tx)
        const result = await waitForTransaction(tx)
        handleTxResult(result)
      }
    }
  }, [pendingTxs, waitForTransaction, processingTxs])

  useEffect(() => {
    if (!isEmpty(pendingTxs)) {
      onTxHandling()
    }
  }, [pendingTxs])
}
